import React, {
    useState,
    FormEvent
} from 'react';
import { Device } from '@capacitor/device';
import { Storage } from '@capacitor/storage';
import { NativeBiometric, AvailableResult, BiometryType, Credentials } from "capacitor-native-biometric";
import { isPlatform } from '@ionic/react';
import { Buffer } from 'buffer';


// for crypto
const CryptoJS = require("crypto-js");

export class AccountInfo {
    id : number = -1;
    key : string = "";
    biometric : boolean = false;
};

// for communiting with server
export default class Vault
{
    public account : AccountInfo = new AccountInfo();
    public savedAccounts : AccountInfo[] = [];

    private ENC_KEY : string = "987654abcdef3210ab76543210cdef98";
    private IV : string = "abcdef9876543210abcdef9876543210";

    // read data from the vault
    async read() {
        
        // get device ID
        const device = await Device.getId();
        var bufferText = Buffer.from(device.uuid); 
        var hex = bufferText.toString('hex');

        // read from storage
        const d = await Storage.get({ key: 'd' });
        const data = d.value as string;

        let obj = JSON.parse(data);
        if (obj == null)
            return;

        let ID = obj.id;
        if (ID != 13)
            return;

        this.account = obj.cur;
        this.savedAccounts = obj.acclist;
    }

    // write data from the vault
    async write() {
        // get device ID
        const device = await Device.getId();
        var bufferText = Buffer.from(device.uuid); 
        var hex = bufferText.toString('hex');

        const state = {
            id: 13,
            cur : this.account,
            acclist : this.savedAccounts
        };
        var d = JSON.stringify(state);

        var key = hex;
        var iv = CryptoJS.enc.Hex.parse(this.IV);
        var cipherData = CryptoJS.AES.encrypt(d, key, { iv: iv });

        const saveData = async () => { 
            await Storage.set({
                key: 'd',
                value: '' + d,
            });
        };
        await saveData();
    }

    // save the current account list to the array
    saveCurAccount() {
        // check whether we have this account saved or not
        for (let i = 0; i < this.savedAccounts.length; i++)
        {
            if (this.savedAccounts[i].id == this.account.id)
                return;     // already saved
        }

        this.savedAccounts.push(this.account);
        // max 8 account to save
        if (this.savedAccounts.length > 8)
            this.savedAccounts.pop();
    }

    // log into save account
    loginSavedAccount(id : number) : boolean
    {
        // check whether we have this account saved or not
        for (let i = 0; i < this.savedAccounts.length; i++)
        {
            if (this.savedAccounts[i].id == id)
            {
                this.account = this.savedAccounts[i];
                return true;
            }
        }
        // else
        return false;
    }

    // delete the saved account
    deleteSavedAccount(id : number)
    {
        // check whether we have this account saved or not
        for (let i = 0; i < this.savedAccounts.length; i++)
        {
            if (this.savedAccounts[i].id == id)
            {
                this.savedAccounts.splice(i, 1);
                return;
            }
        }
    }

    // save the biometric
    async saveBiometric(on : boolean, server : string, username : string, password : string)
    {
        // save to biometric
        if (isPlatform("mobile"))
        {
            NativeBiometric.isAvailable().then(
                    (result: AvailableResult) => {
                    const isAvailable = result.isAvailable;
                    
                    if (isAvailable)
                    {
                        if (on)
                        {
                            // set key
                            NativeBiometric.setCredentials({
                                username: username,
                                password: password,
                                server: server,
                            }).then();
                        }
                        else
                        {
                            // remove key
                            NativeBiometric.deleteCredentials({
                                server: server,
                            }).then();
                        }
                    }
                }
            );
        }

        // save in the vault
        this.account.biometric = on;

        // also save into saved account
        for (let i = 0; i < this.savedAccounts.length; i++)
        {
            if (this.savedAccounts[i].id == this.account.id)
            {
                this.savedAccounts[i].biometric = on;
            }
        }
    }

    // retrieve the biometric password
    biometricLogin(server : string, loginFunc : any, errorFunc : any)
    {
        // retrieve from biometric
        if (isPlatform("mobile"))
        {
            // Check if biometrics are available and which type is supported
            NativeBiometric.isAvailable().then(
                (result: AvailableResult) => {
                    const isAvailable = result.isAvailable;
                    const isFaceId = result.biometryType == BiometryType.FACE_ID;

                if (isAvailable) {
                    // Get user's credentials
                    NativeBiometric.getCredentials({
                        server: server,
                    }).then((credentials: Credentials) => {
                        // Authenticate using biometrics before logging the user in
                        NativeBiometric.verifyIdentity().then(
                            () => {
                                // Authentication successful
                                loginFunc(credentials.username, credentials.password);
                            },
                            (error) => {
                                // Failed to authenticate
                                errorFunc();
                            }
                        );
                    });
                }
              },
              (error) => {
                    // Couldn't check availability
                    errorFunc();
                }
            );
        }
    }
};

// retrieve first time info
export const FirstTime = async (name : string) : Promise<boolean> => {
	const d = await Storage.get({ key: "ft" + name });
    let first = true;
    if (d != null)
    {
        if (d.value != null)
            first = false;
    }

    // save first time
    await Storage.set({
        key: "ft" + name,
        value: "yes",
    });

    // save first time
	return first;
};
